import { LanguageCodes } from '@nx-customer-apps/shared/enums';
import { EnumDictionary } from '../types';

export const languageToLocale: EnumDictionary<LanguageCodes, string> = {
    [LanguageCodes.en]: 'en-DE',
    [LanguageCodes.de]: 'de-DE',
    [LanguageCodes.fr]: 'fr-BE',
    [LanguageCodes.nl]: 'nl-BE',
    [LanguageCodes.cs]: 'cs-CZ',
    [LanguageCodes.sk]: 'sk-SK',
    [LanguageCodes.pl]: 'pl-PL',
    [LanguageCodes.es]: 'es-ES'
};
